module.exports = __webpack_public_path__ + "static/img/package_1.9077e7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_1.jpg
// module id = sPaB
// module chunks = 1